/** @module AQL/Defect/SelectFIDefect */
define([
	"dojo/_base/declare",
	"csi/table/NewSaveOnly",
	"csi",
	"csi/xml",
	"csi/xml/Query"
], function(declare, NewSaveOnly,csi,xml,Query) {

	return declare(NewSaveOnly, {
	
		
		ATTR_ASSORTMENT_STYLE: "AssortmentStyle",
		
		DEFECT_ATTR_COLORWAYS: "Colorways",
		DEFECT_ATTR_PART_MATERIALS: "FIPartMaterials",
		
		TEST_ATTR_COLORWAY: "Colorway",
		TEST_ATTR_PART_MATERIAL: "FIPartMaterial",

		/**
		 * Filter defects by Colorway and/or FIPArtMaterial
		 * @param {csi.view.Widget} view
		 */
		applyActionFilters: function(view) {
			const q = new Query();
			
			const parentNode = this.getParent();
			const isActionOnSection = (xml.nodeGetType(parentNode) == "FinalInspectionBatchSection");
			const isActionOnTest = !isActionOnSection;
			const section = (isActionOnSection ? parentNode : this.getCache().getNode(parentNode.__Parent__));
			if (section) {
				q.Or().Attr(this.ATTR_ASSORTMENT_STYLE, xml.OP_EQUALS, section[this.ATTR_ASSORTMENT_STYLE])
					.Attr(this.ATTR_ASSORTMENT_STYLE, xml.OP_NULL)
					.Attr(this.ATTR_ASSORTMENT_STYLE, xml.OP_EQUALS, csi.EMPTY_URL);
			}

			if (isActionOnTest) {
				const test = parentNode;
				if (test && xml.isValidURL(test[this.TEST_ATTR_COLORWAY])) {
					q.Or().Attr(this.DEFECT_ATTR_COLORWAYS, xml.OP_EQUALS, test[this.TEST_ATTR_COLORWAY])
						.Attr(this.DEFECT_ATTR_COLORWAYS, xml.OP_NULL);
				}
				
				if (test && xml.isValidURL(test[this.TEST_ATTR_PART_MATERIAL])) {
					q.Or().Attr(this.DEFECT_ATTR_PART_MATERIALS, xml.OP_EQUALS, test[this.TEST_ATTR_PART_MATERIAL])
						.Attr(this.DEFECT_ATTR_PART_MATERIALS, xml.OP_NULL);
				}
			}
			
			view.relRoot.addQuery(q);
			this.inherited(arguments);
		}
	});
});